import { render } from "./EmojiNew.vue?vue&type=template&id=4865ff64&scoped=true"
import script from "./EmojiNew.vue?vue&type=script&lang=js"
export * from "./EmojiNew.vue?vue&type=script&lang=js"

import "./EmojiNew.vue?vue&type=style&index=0&id=4865ff64&lang=css"
import "./EmojiNew.vue?vue&type=style&index=1&id=4865ff64&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4865ff64"]])

export default __exports__